import * as _ from "lodash"

import { BaseDto } from "./base.dto"
import { TranslationDto } from "./translation.dto"

export class FindLocationDto {
  searchText?: string
}

export class LocationDto extends BaseDto {
  name: TranslationDto
  enabled: boolean

  static create() {
    return _.assign<LocationDto>({
      name : TranslationDto.create()
    })
  }
}

export class CreateLocationDto {
  name: TranslationDto
}

export class UpdateLocationDto {
  enabled?: boolean
  name?: TranslationDto
}